/**
 * Copyright (C) Siemens AG 1996-2026 ALL RIGHTS RESERVED.
 */

import {Component, inject} from '@angular/core';
import {IxActiveModal} from '@siemens/ix-angular';

@Component({
  selector: 'app-modal-grant-access-request',
  templateUrl: './modal-grant-access-request.component.html',
  standalone: false,
})
export class ModalGrantAccessRequestComponent {
  readonly activeModal = inject(IxActiveModal);

  confirm(): void {
    this.activeModal.close(undefined);
  }
}
